import { ValidatorFn } from '@angular/forms';
import { InputControlType } from '../../enum/input-control-type.enum';
import { MaxLengthValidator, NumberMaxValueValidator, NumberMinValueValidator } from '../validations';
import { AttrAutocomplete } from './../../types';
import { BaseInput, BaseInputConstructor } from './base-input';
/**
 * Represents the constructor options for TextInput.
 *
 * @extends BaseInputConstructor
 */
export interface TextInputConstructor extends BaseInputConstructor {
    /**
     * The type of the input control.
     */
    type: InputControlType;
    maxlength?: number | string | null;
    min?: number;
    max?: number;
    autocomplete?: AttrAutocomplete;
}

/**
 * Represents a text input field, which is a UI component allowing the user to enter text.
 *
 * @extends BaseInput
 */
export class TextInput extends BaseInput {
    /**
     * Specifies the type of input as 'textbox'.
     */
    override inputType = 'textbox';
    override readonly __internalConstructor__: TextInputConstructor;

    /**
     * The type of the input control.
     */
    type: InputControlType;
    maxlength: number | string | null = null;
    min?: number;
    max?: number;
    autocomplete?: AttrAutocomplete = 'off';

    /**
     * Creates a new instance of TextInput.
     *
     * @param options - The options for configuring the text input.
     *
     * @property {InputControlType} options.type - The type of the input control.
     */
    constructor(options: TextInputConstructor) {
        super(options);
        this.__internalConstructor__ = options;
        this.type = options.type;
        this.maxlength = options.maxlength || 255;
        this.min = options.min;
        this.max = options.max;
        if ('undefined' !== typeof options.autocomplete) {
            this.autocomplete = options.autocomplete;
        }

        const validators: ValidatorFn[] = [];
        if (this.validator) {
            validators.push(this.validator);
        }

        if (options?.maxlength) {
            validators.push(MaxLengthValidator());
        }

        // se min è uguale a zero lo prende come false
        if (options?.min !== undefined && options.type === 'number') {
            validators.push(NumberMinValueValidator());
        }

        // se max è uguale a zero lo prende come false
        if (options?.max !== undefined && options.type === 'number') {
            validators.push(NumberMaxValueValidator());
        }

        this.setValidators(validators);
    }

    clone(): TextInput {
        return new TextInput(this.__internalConstructor__);
    }
}
